import styled from 'styled-components'

export const PaginationContainer = styled.div`
  display: flex;
  justify-content: end;
  margin-top: ${props => props.theme.spacing.sp24};
`

export const ExceptionItemsContainer = styled.div`
  margin-bottom: ${props => props.theme.spacing.sp24};
`
